import { forEach } from 'lodash'

export default function(options) {
  this.listId = options.listId
  this.loadMoreId = options.loadMoreId
  this.searchId = options.searchId
  this.itemSelector = options.itemSelector
  this.sorterSelector = options.sorterSelector
  this.classAscending = options.classAscending
  this.classDescending = options.classDescending
  this.classActive = options.classActive
  this.stateSelectId = options.stateSelectId
  this.perPage = options.perPage
  this.shown = options.perPage
  this.list = document.getElementById(this.listId)
  this.totalInstitutions = document.querySelectorAll(
    '#' + this.listId + ' ' + this.itemSelector
  ).length
  let vm = this

  this.init = function() {
    if (vm.totalInstitutions === 0) {
      return
    }

    vm.initializePage()
    vm.initializeSorter()
    vm.initializeFilter()
    vm.initializeStateDropDown()
  }

  this.sortElements = function(sortBy, descending) {
    descending = descending ? 1 : -1
    let items = document.querySelectorAll(
      '#' + vm.listId + ' ' + vm.itemSelector
    )
    let itemsArr = []
    forEach(items, item => {
      itemsArr.push(item)
    })

    itemsArr.sort(function(a, b) {
      let valueA = a.getAttribute('data-' + sortBy)
      let valueB = b.getAttribute('data-' + sortBy)
      if (sortBy === 'lender' || sortBy === 'score') {
        return valueA.localeCompare(valueB) * descending
      }
      return valueA === valueB
        ? 0
        : parseFloat(valueA) > parseFloat(valueB)
        ? -1 * descending
        : descending
    })

    forEach(itemsArr, item => {
      vm.list.appendChild(item)
    })

    vm.shown = vm.perPage
    vm.showInstitutions()
  }

  this.initializePage = function() {
    vm.showInstitutions()

    let moreReviews = document.getElementById(vm.loadMoreId)
    moreReviews.addEventListener(
      'click',
      event => {
        event.preventDefault()
        vm.shown += vm.perPage
        vm.showInstitutions()
      },
      false
    )
  }

  this.showInstitutions = function() {
    vm.setShowMoreVisibility()
    vm.hideInstitutions()
    let items = document.querySelectorAll(
      '#' + vm.listId + ' ' + vm.itemSelector
    )
    forEach(items, (item, index) => {
      if (index < vm.shown) {
        item.style = ''
      }
    })
  }

  this.hideInstitutions = function() {
    let items = document.querySelectorAll(
      '#' + vm.listId + ' ' + vm.itemSelector
    )
    forEach(items, item => {
      item.style = 'display: none'
    })
  }

  this.handleSort = function() {
    let sortBy = this.getAttribute('data-sort')
    let descending = !this.classList.contains(vm.classDescending)
    vm.resetSorters()
    vm.resetFilter()
    this.classList.remove(descending ? vm.classAscending : vm.classDescending)
    this.classList.add(descending ? vm.classDescending : vm.classAscending)
    this.classList.add(vm.classActive)
    vm.sortElements(sortBy, descending)
  }

  this.handleFilter = function() {
    let value = this.value.toLowerCase()
    if (value === '') {
      vm.shown = vm.perPage
      vm.showInstitutions()
      return
    }

    vm.hideInstitutions()
    vm.shown = vm.totalInstitutions
    vm.setShowMoreVisibility()
    let items = document.querySelectorAll(
      '#' + vm.listId + ' ' + vm.itemSelector
    )
    forEach(items, item => {
      let lender = item.getAttribute('data-lender').toLowerCase()
      if (lender.indexOf(value) !== -1) {
        item.style = ''
      }
    })
  }

  this.initializeSorter = function() {
    let sorters = document.querySelectorAll(vm.sorterSelector)
    forEach(sorters, sorter => {
      sorter.addEventListener('click', vm.handleSort, false)
    })
  }

  this.resetSorters = function() {
    let sorters = document.querySelectorAll(vm.sorterSelector)
    forEach(sorters, sorter => {
      sorter.classList.remove(vm.classAscending)
      sorter.classList.remove(vm.classDescending)
      sorter.classList.remove(vm.classActive)
    })
  }

  this.setShowMoreVisibility = function() {
    let moreReviews = document.getElementById(vm.loadMoreId)
    moreReviews.style = vm.shown >= vm.totalInstitutions ? 'display: none' : ''
  }

  this.initializeFilter = function() {
    let filter = document.getElementById(vm.searchId)
    filter.addEventListener('keyup', vm.handleFilter, false)
  }

  this.resetFilter = function() {
    let filter = document.getElementById(vm.searchId)
    filter.value = ''
  }

  this.initializeStateDropDown = function() {
    const dropdown = document.getElementById(this.stateSelectId)
    dropdown.addEventListener('change', () => {
      window.location = dropdown.options[dropdown.selectedIndex].value
    })
  }
}
